var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',{attrs:{"title":_vm.t('Service Modules')}},[_c('ItemList',{attrs:{"fields":_vm.fields,"items":_vm.modules,"full":false},on:{"edit":_vm.onEdit,"test":_vm.onTest}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }